<template>
    <div class="btn-feedback">
        <base-button
            v-bind="button_props"
            :color="current_color"
            :block="true"
            :disabled="is_disabled"
            v-on="$listeners"
        >
            <span
                v-if="status !== null"
                class="status-indicator"
            >
                <open-icon v-if="status === true" glyph="check-circle-o" />
                <open-icon v-else glyph="close" />
            </span>
            <span :class="{ 'uk-invisible': (status !== null) }"><slot></slot></span>
        </base-button>
        <slot v-if="status !== null" name="message"></slot>
    </div>
</template>

<script>
import BaseButton from "./BaseButton"
import OpenIcon from "./OpenIcon"

let timer = null

export default {
    name: "FeedbackButton",
    components: {
        BaseButton,
        OpenIcon
    },
    watch: {
        status: "reset_timer"
    },
    methods: {
        reset_timer () {
            if(timer) {
                clearTimeout(timer)
                timer = null
            }
            if(!!this.dismissAfter && (this.status !== null)) {
                timer = setTimeout(() => {
                    timer = null
                    this.$emit("dismiss")
                }, this.dismissAfter)
            }
        }
    },
    computed: {
        button_props () {
            const { status, dismissAfter, disabled, block, color, ...button_props } = this.$props
            return button_props
        },
        current_color () {
            if(this.status === true) return "success"
            if(this.status === false) return "danger"
            return this.color
        },
        is_disabled () {
            return this.disabled || (this.singleUse && (this.status !== null))
        }
    },
    props: {
        status: {
            validator: prop => (prop === null) || (prop === false) || (prop === true),
            default: null
        },
        label: {
            type: String,
            validator: prop => !!prop
        },
        type: {
            type: String,
            default: "button"
        },
        flavor: {
            type: String,
            validator: prop => !prop || prop.match(/^(link|normal)$/i),
            default: "normal"
        },
        color: {
            type: String,
            validator: prop => !prop || prop.match(/^(primary|regular|success|danger)$/i),
            default: "regular"
        },
        size: {
            type: String,
            validator: prop => !prop || prop.match(/^(mini|small|medium|large)$/i),
            default: "medium"
        },
        active: {
            type: Boolean,
            default: false
        },
        waiting: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        singleUse: {
            type: Boolean,
            default: false
        },
        dismissAfter: { // In milliseconds; 0 never dismisses
            type: Number,
            validator: prop => prop >= 0,
            default: 7000
        }
    }
}
</script>

<style lang="less">
.btn-feedback {
    .status-indicator {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
